import { ChevronRight } from 'lucide-react';

type ViewHintProps = {
  label?: string;
};

export function ViewHint({ label = 'View' }: ViewHintProps) {
  return (
    <div className="opacity-0 group-hover:opacity-100 flex items-center gap-1 text-blue-600 text-xs font-medium px-2 flex-shrink-0 self-center">
      <span>{label}</span>
      <ChevronRight className="w-3 h-3" />
    </div>
  );
}
